import script from "./MembersBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./MembersBar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QTooltip});
